import React, { useEffect } from 'react';
import { useStateMachine } from 'little-state-machine';
/* import { useMsal } from '@azure/msal-react';
 */ import { PageContentContainer } from '../layout/PageContentContainer';
import { PageTitle } from '../layout/components/page/PageTitle';
import { Breadcrumbs } from '../layout/components/page/Breadcrumbs';
import { InvoiceDetailModal } from '../components/dialog/InvoiceDetailModal/InvoiceDetailModal';
import { InvoiceTable } from '../tables/InvoiceTable';
import { Invoice } from '../../../dto/Invoice';
import { useMsal } from '@azure/msal-react';
import { useDismissedQuery } from '../../../query/DismissedQuery copy';
import { checkAuthorisation } from '../checkAuthorisation';
import { LinearProgress } from '@material-ui/core';

const filterData = (
  account: string,
  invoices?: Invoice[] | undefined
): Invoice[] | undefined => {
  if (!invoices) return undefined;
  const accountIntern = account.replace('@intern.', '@');
  return invoices.filter((invoice) => {
    return (
      invoice.acceptors.includes(account.toLowerCase()) ||
      invoice.mailObserver.includes(account.toLowerCase()) ||
      invoice.acceptors.includes(accountIntern.toLowerCase()) ||
      invoice.mailObserver.includes(accountIntern.toLowerCase()) ||
      checkAuthorisation(account.toLowerCase()) ||
      checkAuthorisation(accountIntern.toLowerCase())
    );
  });
};

export const DismissedPage = (): JSX.Element => {
  const filterStatus = ['9'];
  const { data, error, refetch, isLoading, isFetching } = useDismissedQuery({
    invoiceStatus: filterStatus,
  });
  const { state } = useStateMachine();
  const { accounts } = useMsal();

  useEffect(() => {
    if (state.selectedInvoice === undefined) {
      refetch();
    }
  }, [state.selectedInvoice]);

  const filteredData = filterData(accounts[0].username!, data?.invoices);

  return (
    <PageContentContainer>
      <PageTitle>Rechnungen Abgelehnt</PageTitle>
      <Breadcrumbs
        pageTitle="Abgelehnt"
        entries={[{ name: 'Dashboard', to: '/' }]}
      />
      <div>
        {error && (
          <>
            <p style={{ color: 'red' }}>
              Derzeit besteht keine Verbindung zum Server
            </p>
          </>
        )}
        {(isLoading || isFetching) && <LinearProgress color="secondary" />}
        {data && <InvoiceTable invoiceData={filteredData!} />}
      </div>
      {state.selectedInvoice !== undefined && (
        <InvoiceDetailModal config="dismissed" queryString="dismissed" />
      )}
    </PageContentContainer>
  );
};
